/* src/app/components/lead-details/documents/file-upload/file-upload/file-upload.component.css */
[nz-icon] {
  margin-right: 6px;
  font-size: 1.429rem;
  color: #3c86f5;
  cursor: pointer;
}
.auth-table-width {
  width: 55rem;
}
::ng-deep .ant-form-item-label {
  text-align: left;
  margin-bottom: 10px;
  font-weight: 600;
}
/*# sourceMappingURL=file-upload.component-O566JW2I.css.map */
